<ng-container *ngIf="(results | async)?.length">
  <div class="users-layout" *ngFor="let workingUser of results | async">
    <cc-user [user]="workingUser.user"></cc-user>

    <ng-template
      [ngxPermissionsOnly]="'AGENT_LISTENING_PERMISSION'"
      [ngxPermissionsOnlyThen]="thenBlock"
      [ngxPermissionsOnlyElse]="elseBlock">
    </ng-template>
    <ng-template #elseBlock>
      <div></div>
    </ng-template>
    <ng-template #thenBlock>
      <div *ngIf="isUserBusy(workingUser.user)">
        <span *ngIf="isWiredUser(workingUser.user)">
          <a (click)="stopListening()">
            <i class="material-icons recording-icon pause-icon">pause_circle_outline</i>
          </a>
        </span>
          <span *ngIf="!isWiredUser(workingUser.user)">
          <a (click)="listenAgent(workingUser.user)">
            <i class="material-icons recording-icon play-icon">play_circle_outline</i>
          </a>
        </span>
      </div>
      <div *ngIf="!isUserBusy(workingUser.user)"></div>
    </ng-template>

    <div class="accept-calls">
      <cc-dont-accept-incoming-calls
        dashboardName="inbound"
        [username]="workingUser.user.username"
        [userId]="workingUser.user.id"
        [dontAcceptIncomingCalls]="workingUser.user.doNotAcceptIncomingCalls"
      ></cc-dont-accept-incoming-calls>
    </div>
  </div>
</ng-container>
<cc-no-data
  *ngIf="!(results | async)?.length"
></cc-no-data>
